import React, { useState } from 'react';
import moment from 'moment';
import { Button } from 'reactstrap';
import type { Condition } from '../../../../../models/companies/kyccs/condition';
import { EditNoteModal } from '../editNoteModal';

interface Props {
  condition: Condition;
}

export default function ConditionResults(props: Props) {
  const { condition } = props;
  const [conditionState, setConditionState] = useState<Condition>(condition);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const { kyccId, id } = conditionState;

  return (
    <div>
      <div className="d-flex align-items-center target mb-2">
        <span className="mr-3">
          {conditionState.name}
          {conditionState.birthday != null
            ? `（${moment(conditionState.birthday).format('YYYY年MM月DD日')}）`
            : ''}
        </span>
        {kyccId != null && id != null && (
          <Button outline color="primary" onClick={() => setIsOpenModal(true)}>
            メモ
          </Button>
        )}
      </div>
      {conditionState.results.length > 0 && (
        <table className="table mb-4">
          <thead>
            <tr>
              <th>掲載氏名</th>
              <th>生年月日</th>
              <th>団体名</th>
              <th>団体補足</th>
              <th>媒体</th>
              <th>掲載日</th>
              <th>反社区分</th>
              <th>備考</th>
            </tr>
          </thead>
          <tbody>
            {conditionState.results.map((result, j) => (
              <tr key={j}>
                <td className="name">{result.name}</td>
                <td>{result.birthday}</td>
                <td>{result.organizationName}</td>
                <td>{result.organizationSupple}</td>
                <td>{result.journalName}</td>
                <td>{result.reportedAt}</td>
                <td>{result.antisocialGroup}</td>
                <td>{result.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {conditionState.results.length == 0 && <div>該当者はいませんでした</div>}
      {kyccId != null && id != null && (
        <EditNoteModal
          isOpen={isOpenModal}
          kyccId={kyccId}
          conditionId={id}
          note={conditionState.note ?? ''}
          onClose={() => setIsOpenModal(false)}
          onChangeNote={note => {
            setIsOpenModal(false);
            setConditionState(prev => ({ ...prev, note: note }));
          }}
        />
      )}
    </div>
  );
}
